// City to artists mapping data
// Uses city keys from radioData.json and artist IDs from artistData.ts

export interface CityArtistsMapping {
  cityKey: string;
  artistIds: number[];
}

export const CITY_ARTISTS_DATA: CityArtistsMapping[] = [
  {
    cityKey: "Amsterdam",
    artistIds: []
  },
  {
    cityKey: "Berlin", 
    artistIds: []
  },
  {
    cityKey: "Paris",
    artistIds: []
  },
  {
    cityKey: "Istanbul",
    artistIds: []
  },
  {
    cityKey: "Tokyo",
    artistIds: [4]
  },
  {
    cityKey: "Lisbon",
    artistIds: []
  },
  {
    cityKey: "London",
    artistIds: [1]
  },
  {
    cityKey: "MexicoCity",
    artistIds: [] 
  },
  {
    cityKey: "Montreal",
    artistIds: []
  },
  {
    cityKey: "NewYork",
    artistIds: [2,3] 
  },
  {
    cityKey: "Seoul",
    artistIds: [] 
  },
  {
    cityKey: "Shanghai",
    artistIds: []
  },
  {
    cityKey: "Taipei",
    artistIds: [] 
  },
  {
    cityKey: "Thailand", 
    artistIds: []
  },
  {
    cityKey: "Vancouver",
    artistIds: []
  },
  {
    cityKey: "Sydney",
    artistIds: []
  },
  {
    cityKey: "LosAngeles",
    artistIds: []
  },
  {
    cityKey: "Barcelona",
    artistIds: []
  },
  {
    cityKey: "Roma",
    artistIds: []
  }
];

// Helper function to get artist IDs for a specific city
export const getArtistIdsForCity = (cityKey: string): number[] => {
  const cityData = CITY_ARTISTS_DATA.find(city => city.cityKey === cityKey);
  return cityData ? cityData.artistIds : [];
};
